{
  "title": "Meine mobile App verbinden",
  "form": {
    "mobileApp": {
      "label": "Anwendung Ihrer Wahl auswählen, um den QR-Code zu generieren",
      "placeholder": "Anwendung auswählen",
      "validation": {
        "required": "Sie müssen eine mobile Anwendung auswählen"
      }
    },
    "button": {
      "content": "QR-Code generieren"
    }
  },
  "qrCode": {
    "expirationDate": "Läuft ab am"
  },
  "downloadOfflineAccess": {
    "button": "Parametrierung für den Offline-Zugriff herunterladen"
  },
  "passwordModal": {
    "password": {
      "validation": {
        "pattern": "Das Passwort muss mindestens 12 Zeichen lang sein und Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen enthalten",
        "required": "Sie müssen ein Passwort eingeben"
      },
      "label": "Passwort"
    },
    "title": "Geben Sie das von der My LogUp-Anwendung bereitgestellte Passwort ein"
  }
}
